import React, { useState, useRef, useEffect } from 'react'
import { GoogleMap, LoadScript, Marker, DirectionsRenderer, DirectionsService } from '@react-google-maps/api';
import { useLocation, useNavigate } from "react-router-dom";
import ReactLoading from 'react-loading';





const Mapmarkers = (props) => {

    const location = useLocation();
    const navigate = useNavigate();

    const houses = location.state?.houses;
    //   const latitude = parseFloat(location.pathname.split("/")[2]);
    //   const longitude = parseFloat(location.pathname.split("/")[3]);
    const [house, sethouse] = useState('');

    const longitude = parseFloat(36.0656509);
    const latitude = parseFloat(-0.3005617)
    const [center, setcenter] = useState({
        lat: parseFloat(location.state?.latitude),
        lng: parseFloat(location.state?.longitude)
    });


    const [directions, setdirections] = useState('');
    const [zoomno, setzoomno] = useState(15);

    const GoogleMapsApiKey = "AIzaSyB4Tle4NUq0FQmy8pxMUWsMOOMwVNqt00M"

    const containerStyle = {
        width: '90%',
        margin: "0 auto",
        height: '700px'
    };

    // const center = {
    //     lat: latitude,
    //     lng: longitude
    // };
    let color = "rgb(230, 52, 52)";
    let type = "bars";

    const handlezoom = (e) => {
        if(zoomno < 17){
            const mapcenteer = {
                lat: parseFloat(e.latitude),
                lng: parseFloat(e.longitude)
            };
            sethouse(e)
            setcenter(mapcenteer)
            setzoomno(zoomno + 1)
        }else{
            navigate(`/nav/viewsinglehouse/${house.id}`)
        }
    }




    return (
        <LoadScript
            googleMapsApiKey={GoogleMapsApiKey}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoomno}
            >
                {houses.map((val, key) => {

                    const mapcenter = {
                        lat: parseFloat(val.latitude),
                        lng: parseFloat(val.longitude)
                    };
                    return (
                        <Marker key={key} title={`${val.housename}/${val.type}/ksh ${val.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`} position={mapcenter} onClick={() => handlezoom(val)} />
                    )
                })}

            </GoogleMap>
        </LoadScript>
    )
}

export default Mapmarkers;

